"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AppConfig_1 = require("../../AppConfig");
var ListModeToggleContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: .75rem 0;\n    border-top: 1px solid ", ";\n\n    .breadcrumbs {\n        flex-grow: 1;\n\n        .crumb {\n            color: ", ";\n            cursor: pointer;\n        }\n    }\n"], ["\n    display: flex;\n    padding: .75rem 0;\n    border-top: 1px solid ", ";\n\n    .breadcrumbs {\n        flex-grow: 1;\n\n        .crumb {\n            color: ", ";\n            cursor: pointer;\n        }\n    }\n"])), AppConfig_1.UIConfig.ThemeColorBrightPurple, AppConfig_1.UIConfig.ThemeColorYellow);
var BreadcrumbsData = [
    {
        label: 'timeline',
        value: 'timeline'
    },
    {
        label: 'magnitude',
        value: 'grid'
    }
];
var ListModeToggle = function (_a) {
    var _b = _a.countOfFires, countOfFires = _b === void 0 ? 0 : _b, activeListMode = _a.activeListMode, onChange = _a.onChange;
    var getBreadcrumbs = function () {
        var crumbs = BreadcrumbsData.map(function (d, i) {
            var classNames = classnames_1.default('crumb', {
                'is-active': d.value === activeListMode
            });
            return (React.createElement("span", { key: "listmode-toggle-btn-" + i, className: classNames, onClick: onChange.bind(_this, d.value) }, d.label));
        });
        return (React.createElement("nav", { className: "breadcrumbs" }, crumbs));
    };
    return (React.createElement(ListModeToggleContainer, { className: 'font-size--2' },
        getBreadcrumbs(),
        React.createElement("span", null,
            "total fires in view: ",
            countOfFires)));
};
exports.default = ListModeToggle;
var templateObject_1;
